type SortTypes = string | number;

export const descending = (a: SortTypes, b: SortTypes) => {
  if (typeof a === 'string' && typeof b === 'string' && isNaN(parseInt(a)) && isNaN(parseInt(b))) {
    return descendingString(a, b);
  }

  return (b as number) - (a as number);
};
export const ascending = (a: SortTypes, b: SortTypes) => {
  if (typeof a === 'string' && typeof b === 'string' && isNaN(parseInt(a)) && isNaN(parseInt(b))) {
    return ascendingString(a, b);
  }
  return (a as number) - (b as number);
};

const ascendingString = (a: string, b: string) => a.localeCompare(b);
const descendingString = (a: string, b: string) => b.localeCompare(a);
